export const APPEND_ARTICLE_TAG = "APPEND_ARTICLE_TAG";
export const SET_ARTICLE_TAG_SELECTOR = "SET_ARTICLE_TAG_SELECTOR";
export const SET_ARTICLE_TAG_TIER2_ITEMS = "SET_ARTICLE_TAG_TIER2_ITEMS";
export const SET_SELECTED_TAG_TIER1 = "SET_SELECTED_TAG_TIER1";
export const SET_SELECTED_TAG_TIER2 = "SET_SELECTED_TAG_TIER2";
export const SET_SELECTED_TAG_ENTITY = "SET_SELECTED_TAG_ENTITY";
export const SET_ARTICLE_TAG_NAME = "SET_ARTICLE_TAG_NAME";
export const REMOVE_ARTICLE_TAG = "REMOVE_ARTICLE_TAG";
